module.exports = {
      id: "pre-blue-pavilions-in-the-yard-usage",
      viewBox: "0 0 46 46",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#pre-blue-pavilions-in-the-yard",
      toString: function () {
        return this.url;
      }
    }